export const language: any ={
    cancel: "Abbrechen",
    ok: "Ok",
}